export default __webpack_public_path__ + "static/media/map-caribe.1a253d64.jpg";